
















































































































































import { Component, Prop, Vue } from 'vue-property-decorator';

import { DateLabel } from '@/common/datetime';
import { DailyReport } from '@/models/dailyReport.model';
import IndexPageRolloverLabel from '@/pages/index/pages/index/components/IndexPageRolloverLabel.vue';
import { ConfigStore } from '@/store/config';
import { DailyReportStore } from '@/store/dailyReport';
import { LocationStore } from '@/store/location';


@Component({
  components: {
    DateLabel,
    IndexPageRolloverLabel,
  },
})
export default class IndexPageDailyReportListItem extends Vue {

  @Prop() isTemperatureShown!: boolean;
  @Prop() overShort!: number;
  @Prop() value!: DailyReport;

  @LocationStore.Bind.Getter heightUoms!: LocationStore.Getter<'heightUoms'>;
  @DailyReportStore.Bind.State isTankFieldsShown!: DailyReportStore.State<'isTankFieldsShown'>;
  @ConfigStore.Bind.State processRolloverDate!: ConfigStore.State<'processRolloverDate'>;
  @LocationStore.Bind.Getter temperatureUoms!: LocationStore.Getter<'temperatureUoms'>;
  @LocationStore.Bind.Getter volumeUoms!: LocationStore.Getter<'volumeUoms'>;

  get isRollover() {
    return this.value.date === this.processRolloverDate;
  }

  get isBeforeRollover() {
    return this.value.date.localeCompare(this.processRolloverDate) < 0;
  }

  goToDetails() {
    this.$router.push(`/edit/${this.value.date}`);
  }

}
